export const SMART_CHARGING_ROUTES = {
  START: "/smart-charging/add-wallbox/start/",

  COMPATIBILITY: "/smart-charging/compatibility/comp-check",
  COMPATIBILITY_SALE: "/smart-charging/compatibility/check/",
  MODEL: "/smart-charging/compatibility/check/model",
  MANUFACTURER_SEARCH: "/smart-charging/compatibility/check/other",
  MODEL_SEARCH: "/smart-charging/compatibility/check/other/model",
  STATUS: "/smart-charging/compatibility/check/status",

  TERMS: "/smart-charging/compatibility/terms",
  COMPATIBILITY_SUCCESS: "/smart-charging/compatibility/success",

  ADD_WALLBOX_START: "/smart-charging/add-wallbox/onboarding-start",
  INTRO: "/smart-charging/add-wallbox/intro",
  CONNECT_CONFIRM: "/smart-charging/add-wallbox/connect-confirm",
  CONNECTING: "/smart-charging/add-wallbox/connecting",
  CONNECTING_SUCCESS: "/smart-charging/add-wallbox/connecting-success",
  CONNECTING_ERROR: "/smart-charging/add-wallbox/connecting-error",
  ONBOARDING_SLIDER: "/smart-charging/add-wallbox/onboarding-slider",

  OVERVIEW_START: "/smart-charging/overview/start",
  OVERVIEW_DETAILS: "/smart-charging/overview/details",

  ADD_EV_START: "/smart-charging/add-ev/start/",
  ADD_EV_ONBOARDING_CALLBACK: "/smart-charging/add-ev/onboarding-callback",
  ADD_EV_SUCCESS: "/smart-charging/add-ev/success",
  ADD_EV_FAILED: "/smart-charging/add-ev/failed",
};

export const SMART_CHARGING_COMPATIBILITY_PATHS = [
  SMART_CHARGING_ROUTES.COMPATIBILITY,
  SMART_CHARGING_ROUTES.COMPATIBILITY_SALE,
  SMART_CHARGING_ROUTES.MODEL,
  SMART_CHARGING_ROUTES.TERMS,
  SMART_CHARGING_ROUTES.COMPATIBILITY_SUCCESS,
  SMART_CHARGING_ROUTES.MANUFACTURER_SEARCH,
  SMART_CHARGING_ROUTES.MODEL_SEARCH,
  SMART_CHARGING_ROUTES.STATUS,
];

export const SMART_CHARGING_ONBOARDING_PATHS = [
  SMART_CHARGING_ROUTES.ADD_WALLBOX_START,
  SMART_CHARGING_ROUTES.INTRO,
  SMART_CHARGING_ROUTES.CONNECT_CONFIRM,
  SMART_CHARGING_ROUTES.CONNECTING,
  SMART_CHARGING_ROUTES.CONNECTING_SUCCESS,
  SMART_CHARGING_ROUTES.CONNECTING_ERROR,
  SMART_CHARGING_ROUTES.ONBOARDING_SLIDER,
];

export const SMART_CHARGING_OVERVIEW_PATHS = [
  SMART_CHARGING_ROUTES.OVERVIEW_START,
  SMART_CHARGING_ROUTES.OVERVIEW_DETAILS,
];

export const SMART_CHARGING_ADD_EV_PATHS = [
  SMART_CHARGING_ROUTES.ADD_EV_START,
  SMART_CHARGING_ROUTES.ADD_EV_ONBOARDING_CALLBACK,
  SMART_CHARGING_ROUTES.ADD_EV_SUCCESS,
  SMART_CHARGING_ROUTES.ADD_EV_FAILED,
];

export const SMART_CHARGING_PATHS = [
  SMART_CHARGING_ROUTES.START,
  ...SMART_CHARGING_COMPATIBILITY_PATHS,
  ...SMART_CHARGING_ONBOARDING_PATHS,
  ...SMART_CHARGING_OVERVIEW_PATHS,
  ...SMART_CHARGING_ADD_EV_PATHS,
];
